import types from './types';
import {
    fetchElementsPaginated,
    fetchElement,
    submitElement,
    deleteElement
} from './common';


const apiUrl = '/api/promo-codes';

export function submitPromoCode(values) {
    return submitElement(apiUrl, values, types.SUBMIT_PROMO_CODE);
}
export function fetchPromoCode(itemId) {
    return fetchElement(apiUrl, itemId, types.ADMIN_LOAD_PROMO_CODE);
}

export function fetchPromoCodesPaginated(page = 0, size = 10) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.ADMIN_LOAD_PROMO_CODES);
}

export function deletePromoCode(partner) {
    return deleteElement(apiUrl, partner.id, types.DELETE_PROMO_CODE);
}



// WEBPACK FOOTER //
// ./src/js/actions/promo-codes.js